import { render, staticRenderFns } from "./base-link.vue?vue&type=template&id=14e14d6a&scoped=true"
import script from "./base-link.vue?vue&type=script&lang=js"
export * from "./base-link.vue?vue&type=script&lang=js"
import style0 from "./base-link.vue?vue&type=style&index=0&id=14e14d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e14d6a",
  null
  
)

export default component.exports